<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex mb-3">
          <!-- <b-button-group class="add-button-group">
            <b-btn variant="primary" to="/costumers/create">Tambah Data</b-btn>
          </b-button-group> -->
          <!-- <b-button-group class="add-button-group ml-auto">
            <b-btn variant="success" type="button" @click.prevent="doExport"><font-awesome-icon icon="file-excel"/> Ekspor</b-btn>
          </b-button-group> -->
        </div>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="6" md="6">
              <form-group-input ref="filter-q" type="text" @keyup="filterWithKeyboard" placeholder="" :need-label="true" label="Cari nama/no hp/ nik" v-model="filter.q" id="filter-q" />
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :delete-reason="false" :can-delete="true" :can-edit="true" :data-url="apiUrl.costumer" :data-columns="columns" :dataParams="dataParams" :defaultDataParams="this.filter">
      <template slot="content_nama" slot-scope="defaultSlotScope">
        {{ defaultSlotScope.colData.gender === 'pria' ? 'Bapak' : 'Ibu' }} {{ defaultSlotScope.colData.nama }}
      </template>
    </paginated-table>
  </b-card>
</template>

<script>
import { debounce } from '@/_helpers'
// import { objectToOptions, getYears, formatModelValue } from '@/_helpers'
import paginatedTable from '@/components/PaginatedTable.vue'
import formGroupInput from '@/components/FormGroupInput.vue'
import Costumer from '@/models/Costumer.js'

const costumerModel = new Costumer()

export default {
  components: {
    formGroupInput,
    paginatedTable
  },
  data () {
    return {
      isLoading: false,
      totalPromiseAreaCount: 0,
      apiUrl: {
        costumer: costumerModel.endpoint
      },
      columns: [
        {
          prop: 'nama',
          label: 'Nama',
          sortable: true,
          resizable: true,
          minWidth: 200,
          wrapInLink: true,
        },
        {
          prop: 'no_hp',
          label: 'No. HP',
          resizable: true,
          sortable: true,
          minWidth: 150
        },
        {
          prop: 'nik',
          label: 'NIK',
          resizable: true,
          sortable: true,
          minWidth: 125
        },
      ],
      filter: {
        q: typeof this.$route.query.q !== 'undefined' ? this.$route.query.q : null,
      },
      dataParams: ['q']
    }
  },
  beforeMount () {
    this.$router.push({query: {...this.$route.query}}).catch(err => {})
  },
  methods: {
    filterWithKeyboard() {
      this.debounceFilter(this);
    },
    debounceFilter: debounce((vm) => {
      vm.doFilter()
    }, 350),
    clearForm () {
      this.$nextTick(() => {
        this.filter = {
          q: null,
        }
        setTimeout(() => {
          this.doFilter()
        }, 100)
      })
    },
    doFilter () {
      this.$refs.dataTable.doFilter(this.filter)
    },
    doExport () {
      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      const filterArray = [];
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key]) {
          filterArray.push(key + "=" + this.filter[key]);
        }
      });
      filterArray.push('csv=1');

      this.$http.get(costumerModel.getEndpoint() + "?" + filterArray.join("&")).then(response => {
        const a = document.createElement("a");

        const blob = new Blob([response.data], {type: "octet/stream"});
        a.href = window.URL.createObjectURL(blob);

        a.download = "data_admin.csv";
        a.click();
        this.isLoading = false;
      }).catch(error => {
        this.$store.dispatch('notification/error', error)
        this.isLoading = false;
      })
    }
  }
}
</script>